import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useCreateCompanyMutation,
  useUploadCompanyPhotoMutation,
} from "../slices/companySlice";
import imageCompression from "browser-image-compression";
import {
  Row,
  Form,
  Col,
  Placeholder,
  Button,
  InputGroup,
} from "react-bootstrap";
import { toast } from "react-toastify";
import FieldWarning from "../components/FieldWarning";
import { Eye, EyeSlash } from "react-bootstrap-icons";

const RegistrationScreen = () => {
  const [companyId, setCompanyId] = useState("");
  const [companyCategory, setCompanyCategory] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyCity, setCompanyCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [state, setState] = useState("Select State");
  const [companyContact, setCompanyContact] = useState("");

  const [seperatePlatformFee, setSeperatePlatformFee] = useState(true);
  const [platformFee, setPlatformFee] = useState("");
  const [addedBy, setAddedBy] = useState("");
  const [adminName, setAdminName] = useState("");
  const [adminContact, setAdminContact] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  // Companies are created by Zutle staff only, until the Zutle admin
  // dashboard exists. Never stored — typed for each registration.
  const [zutleSecret, setZutleSecret] = useState("");
  const [zutleSecretPresent, setZutleSecretPresent] = useState(false);
  const [file, setFile] = useState(null);
  const [fileSizeError, setFileSizeError] = useState(false);
  const [fileInvalidError, setFileInvalidError] = useState(false);

  const [companyIdPresent, setCompanyIdPresent] = useState(false);
  const [companyCategoryPresent, setCompanyCategoryPresent] = useState(false);
  const [companyNamePresent, setCompanyNamePresent] = useState(false);
  const [companyAddressPresent, setCompanyAddressPresent] = useState(false);
  const [companyCityPresent, setCompanyCityPresent] = useState(false);
  const [pincodePresent, setPincodePresent] = useState(false);
  const [statePresent, setStatePresent] = useState(false);
  const [companyContactPresent, setCompanyContactPresent] = useState(false);
  const [addedByPresent, setAddedByPresent] = useState(false);
  const [adminNamePresent, setAdminNamePresent] = useState(false);
  const [adminContactPresent, setAdminContactPresent] = useState(false);
  const [passwordPresent, setPasswordPresent] = useState(false);
  const [confirmPasswordPresent, setConfirmPasswordPresent] = useState(false);

  const [pwdVisible, setPwdVisible] = useState(false);
  const [confirmPwdVisible, setConfirmPwdVisible] = useState(false);

  const [seperatePlatformFeePresent, setSeperatePlatformFeePresent] =
    useState(false);
  const [platformFeePresent, setPlatformFeePresent] = useState(false);

  const sepPlatfee = ["Yes", "No"];

  const availableStateNames = [
    "Select State",
    "Andhra Pradesh",
    "Karnataka",
    "Kerala",
    "Maharashtra",
    "Tamil Nadu",
    "Telangana",
  ];

  const navigate = useNavigate();

  const [registerCompany, { isLoading }] = useCreateCompanyMutation();

  const [uploadPhoto, { isLoading: isPhotoUploading }] =
    useUploadCompanyPhotoMutation();

  useEffect(() => {
    if (companyId?.length === 8) {
      setCompanyIdPresent(false);
    }

    if (companyName?.trim().length > 0) {
      setCompanyNamePresent(false);
    }

    if (companyAddress?.length > 10) {
      setCompanyAddressPresent(false);
    }

    if (companyCity?.length > 0) {
      setCompanyCityPresent(false);
    }

    if (state != "Select State") {
      setStatePresent(false);
    }

    if (pincode?.length === 6) {
      setPincodePresent(false);
    }

    if (companyContact?.length === 10 && companyContact > 1) {
      setCompanyContactPresent(false);
    }

    if (parseFloat(platformFee) <= 3 && platformFee !== "") {
      setPlatformFeePresent(false);
    }

    if (addedBy?.trim().length > 0) {
      setAddedByPresent(false);
    }

    if (adminName?.trim().length > 0) {
      setAdminNamePresent(false);
    }

    if (adminContact?.length === 10 && adminContact > 1) {
      setAdminContactPresent(false);
    }
    if (password?.trim().length >= 8) {
      setPasswordPresent(false);
    }
    if (password === confirmPassword) {
      setConfirmPasswordPresent(false);
    }
    if (zutleSecret?.length > 0) {
      setZutleSecretPresent(false);
    }
  }, [
    zutleSecret,
    companyId,
    companyName,
    companyAddress,
    companyCity,
    state,
    pincode,
    companyContact,
    platformFee,
    addedBy,
    adminName,
    adminContact,
    password,
    confirmPassword,
  ]);

  const verifyInputFeilds = async () => {
    let fieldValidationSuccess = true;

    if (companyId?.length !== 8) {
      setCompanyIdPresent(true);
      fieldValidationSuccess = false;
    }

    if (companyName?.trim().length < 1 || companyName?.length > 100) {
      setCompanyNamePresent(true);
      fieldValidationSuccess = false;
    }

    if (companyAddress?.length < 10 || companyAddress?.length > 1000) {
      setCompanyAddressPresent(true);
      fieldValidationSuccess = false;
    }

    if (companyCity?.length < 1 || companyCity?.length > 100) {
      setCompanyCityPresent(true);
      fieldValidationSuccess = false;
    }

    if (state === "Select State") {
      setStatePresent(true);
      fieldValidationSuccess = false;
    }

    if (pincode?.length !== 6) {
      setPincodePresent(true);
      fieldValidationSuccess = false;
    }

    if (companyContact?.length !== 10) {
      setCompanyContactPresent(true);
      fieldValidationSuccess = false;
    }

    if (parseFloat(platformFee) > 3 || platformFee === "") {
      setPlatformFeePresent(true);
      fieldValidationSuccess = false;
    }
    if (addedBy?.trim().length < 1 || addedBy?.length > 100) {
      setAddedByPresent(true);
      fieldValidationSuccess = false;
    }

    if (password?.trim().length < 8 || password?.length > 50) {
      setPasswordPresent(true);
      fieldValidationSuccess = false;
    }
    if (password !== confirmPassword) {
      setConfirmPasswordPresent(true);
      fieldValidationSuccess = false;
    }

    if (adminName?.trim().length < 1 || adminName?.length > 100) {
      setAdminNamePresent(true);
      fieldValidationSuccess = false;
    }

    if (adminContact?.length !== 10 || Number(adminContact) < 6000000000) {
      setAdminContactPresent(true);
      fieldValidationSuccess = false;
    }

    if (!zutleSecret) {
      setZutleSecretPresent(true);
      fieldValidationSuccess = false;
    }

    if (!fieldValidationSuccess)
      toast.error(
        `Some of the fields have invalid inputs.
             Please provide valid details`
      );
    return fieldValidationSuccess;
  };

  const submitHandler = async (e) => {
    if (await verifyInputFeilds())
      try {
        const res = await registerCompany({
          _id: companyId,
          separatePlaformFee: seperatePlatformFee,
          platformFee: platformFee,
          companyCategory: companyCategory,
          companyName: companyName,
          companyAddress: companyAddress,
          companyCity: companyCity,
          companyPincode: pincode,
          companyState: state,
          companyContact: companyContact,
          operationStatus: true,
          addedBy: addedBy,
          // The company's primary owner, created together with it.
          owner: {
            adminName: adminName,
            mobileNumber: adminContact,
            password: password,
            confirmPassword: confirmPassword,
          },
          zutleSecret: zutleSecret,
        }).unwrap();
        if (res && file) {
          try {
            let formData = new FormData();
            formData.append("image", file);
            formData.append(
              "imageKey",
              companyId + "" + companyId + "" + companyId
            );
            await uploadPhoto({
              payload: formData,
            }).unwrap();
          } catch (e) {
            // The company exists already; the photo can be added later.
            toast.error("Company created, but the photo upload failed");
          }
        }
        if (res) {
          toast.success(
            "Company and owner created. The owner can now log in with their mobile number."
          );
          navigate("/login");
        }
      } catch (e) {
        toast.error(e?.data?.error || "Something Went Wrong");
      }
  };

  const goToLogin = () => {
    navigate("/login");
  };
  const setPwdVisibility = () => {
    setPwdVisible(!pwdVisible);
  };
  const setConfirmPwdVisibility = () => {
    setConfirmPwdVisible(!confirmPwdVisible);
  };

  const compressImage = async (selectedImage) => {
    const file = selectedImage;
    if (file) {
      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 280,
          useWebWorker: true,
          initialQuality: 1,
        };

        console.log("Un-Compressed file:", file);
        const compressedFile = await imageCompression(file, options);
        // setFile(compressedFile);
        console.log("first Compressed file:", compressedFile);
        const secondOptions = {
          maxSizeMB: 1, // maximum size in MB
          useWebWorker: true, // use web worker for performance
          initialQuality: 0.9, // initial quality setting
        };

        // Second compression step
        const secondCompressedFile = await imageCompression(
          compressedFile,
          secondOptions
        );
        console.log("Second Compressed file:", secondCompressedFile);
        setFile(secondCompressedFile);

        // // You can now upload the compressed file to your server
        // uploadImage(compressedFile);
      } catch (error) {
        console.error("Error processing image:", error);
      }
    }
  };

  const handleFileChange = async (e) => {
    const selectedFile = e?.target?.files[0];
    const dotIndex = selectedFile?.name?.lastIndexOf(".");
    const fileExtension = selectedFile?.name?.slice(dotIndex + 1).toLowerCase();
    let errorPresent = false;
    if (
      !(
        fileExtension === "jpeg" ||
        fileExtension === "jpg" ||
        fileExtension === "png" ||
        fileExtension === "tiff" ||
        fileExtension === "svg" ||
        fileExtension === "jfif"
      )
    ) {
      errorPresent = true;
      setFileInvalidError(true);
      setFile(null);
    } else if (selectedFile?.size / 1000 > 5120) {
      setFileSizeError(true);
      setFile(null);
    } else if (!errorPresent && selectedFile?.size / 1000 <= 5120) {
      setFileSizeError(false);
      setFileInvalidError(false);
      // setFile(selectedFile);
      await compressImage(selectedFile);
    }
  };

  return (
    <Row
      style={{
        display: "flex",
        margin: "5rem",
        marginLeft: "5rem",
        alignItems: "center",
        justifyContent: "center",
        width: "100",
      }}
    >
      <Row>
        <Form.Group as={Row}>
          <Form.Label column="true" sm="3">
            <strong>
              {" "}
              Company Id<label style={{ color: "red" }}>*</label>
            </strong>
          </Form.Label>
          <Col sm="6">
            <Form.Control
              type="text"
              patter="[0-9]"
              value={companyId}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                setCompanyId(value);
              }}
              placeholder="Enter Company Id"
            />
            {companyIdPresent ? (
              <FieldWarning text="Please provide valid Company ID" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column="true" sm="3">
            <strong>
              {" "}
              Company Name<label style={{ color: "red" }}>*</label>
            </strong>
          </Form.Label>
          <Col sm="6">
            <Form.Control
              type="text"
              patter="[A-Za-z]+"
              value={companyName}
              onChange={(e) => {
                const value = e.target.value.replace(/[^A-Za-z ]/g, "");
                setCompanyName(value);
              }}
              placeholder="Enter Company Name"
            />
            {companyNamePresent ? (
              <FieldWarning text="Company Name should have minimum 1 char and max 100 char" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column="true" sm="3">
            <strong>
              {" "}
              Company Category<label style={{ color: "red" }}>*</label>
            </strong>
          </Form.Label>
          <Col sm="6">
            <Form.Control
              type="text"
              patter="[A-Za-z]+"
              value={companyCategory}
              onChange={(e) => {
                const value = e.target.value.replace(/[^A-Za-z]/g, "");
                setCompanyCategory(value);
              }}
              placeholder="Enter Company Category"
            />
            {companyCategoryPresent ? (
              <FieldWarning text="Please provide Company Category" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column="true" sm="3">
            <strong>
              {" "}
              Company Address<label style={{ color: "red" }}>*</label>
            </strong>
          </Form.Label>
          <Col sm="6">
            <Form.Control
              type="text"
              value={companyAddress}
              onChange={(e) => {
                setCompanyAddress(e.target.value);
              }}
              placeholder="Enter Company address"
            />
            {companyAddressPresent ? (
              <FieldWarning text="Address should be atleast 10 chars long" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column="true" sm="3">
            <strong>
              {" "}
              City<label style={{ color: "red" }}>*</label>
            </strong>
          </Form.Label>
          <Col sm="6">
            <Form.Control
              type="text"
              value={companyCity}
              onChange={(e) => {
                const value = e.target.value.replace(/[^A-Za-z]/g, "");
                setCompanyCity(value);
              }}
              placeholder="Enter the City"
            />
            {companyCityPresent ? (
              <FieldWarning text="Please enter your city" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column="true" sm="3">
            <strong>
              {" "}
              Pincode<label style={{ color: "red" }}>*</label>
            </strong>
          </Form.Label>
          <Col sm="6">
            <Form.Control
              type="text"
              pattern="[0-9]"
              value={pincode}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                setPincode(value);
              }}
              placeholder="Enter Pincode"
            />
            {pincodePresent ? (
              <FieldWarning text="Please provide valid 6 digit Pincode" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="my-2" controlId="subscriptionType">
          <Form.Label column="true" sm="3">
            <strong>State</strong>
            <label style={{ color: "red" }}>*</label> :
          </Form.Label>
          <Col sm="6">
            <Form.Select
              value={state}
              onChange={(e) => setState(e.target.value)}
              placeholder="Select State"
            >
              {availableStateNames?.map((e) => (
                <option key={e} value={e}>
                  {e}
                </option>
              ))}
            </Form.Select>
            {statePresent ? <FieldWarning text="Please Select State" /> : ""}
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column="true" sm="3">
            <strong>
              {" "}
              Company Contact<label style={{ color: "red" }}>*</label>
            </strong>
          </Form.Label>
          <Col sm="6">
            <Form.Control
              type="text"
              patter="[0-9]"
              value={companyContact}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                setCompanyContact(value);
              }}
              placeholder="Enter Contact number"
            />
            {companyContactPresent ? (
              <FieldWarning text="contact number should be 10 digits long" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="my-2" controlId="gender">
          <Form.Label column="true" sm="3">
            <strong>
              {" "}
              Seperate Platform Fee ?<label style={{ color: "red" }}>*</label>
            </strong>
          </Form.Label>
          <Col sm="6">
            <div className="horizontal-radio-group">
              {sepPlatfee?.map((option) => (
                <Form.Check
                  key={option}
                  type="radio"
                  label={option}
                  name="platRadio"
                  id={`platRadio-${option}`}
                  value={option}
                  checked={seperatePlatformFee === (option === "Yes")}
                  onChange={(e) =>
                    setSeperatePlatformFee(e.target.value === "Yes")
                  }
                />
              ))}
            </div>
            {seperatePlatformFeePresent ? (
              <FieldWarning text="Please select your preference" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column="true" sm="3">
            <strong>
              {" "}
              Platform Fee %<label style={{ color: "red" }}>*</label>
            </strong>
          </Form.Label>
          <Col sm="6">
            <Form.Control
              type="text"
              pattern="[0-9]"
              value={platformFee}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                setPlatformFee(value);
              }}
              placeholder="Enter Platformfee"
            />
            {platformFeePresent ? (
              <FieldWarning text="Platformfee should not be more than 3" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>

        <Form.Group as={Row}>
          <Form.Label column="true" sm="3">
            <strong> Registered By</strong>
          </Form.Label>
          <Col sm="6">
            <Form.Control
              type="text"
              patter="[A-Za-z]+"
              value={addedBy}
              onChange={(e) => {
                const value = e.target.value.replace(/[^A-Za-z]/g, "");
                setAddedBy(value);
              }}
              placeholder="Enter  Name"
            />
            {addedByPresent ? (
              <FieldWarning text="Please provide your name" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column="true" sm="3">
            <strong>
              {" "}
              Admin Name<label style={{ color: "red" }}>*</label>
            </strong>
          </Form.Label>
          <Col sm="6">
            <Form.Control
              type="text"
              patter="[A-Za-z]+"
              value={adminName}
              onChange={(e) => {
                const value = e.target.value.replace(/[^A-Za-z ]/g, "");
                setAdminName(value);
              }}
              placeholder="Enter Owner Name"
            />
            {adminNamePresent ? (
              <FieldWarning text="Owner Name should have minimum 1 char and max 100 char" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Form.Label column="true" sm="3">
            <strong>
              {" "}
              Admin Contact<label style={{ color: "red" }}>*</label>
            </strong>
          </Form.Label>
          <Col sm="6">
            <Form.Control
              type="text"
              patter="[0-9]"
              value={adminContact}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, "");
                setAdminContact(value);
              }}
              placeholder="Enter Contact number"
            />
            {adminContactPresent ? (
              <FieldWarning text="Please provide contact number" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="my-2" controlId="password">
          <Form.Label column="true" sm="3">
            <strong>
              {" "}
              Password <label style={{ color: "red" }}>*</label>{" "}
            </strong>
            :
          </Form.Label>
          <Col sm="6">
            <div style={{ display: "flex" }}>
              <InputGroup>
                <Form.Control
                  type={pwdVisible ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="enter password"
                ></Form.Control>
                <Button
                  className="cyanThemeHeaderTop"
                  onClick={setPwdVisibility}
                >
                  {pwdVisible ? <Eye /> : <EyeSlash />}
                </Button>
              </InputGroup>
            </div>
            {passwordPresent ? (
              <FieldWarning text="Password should be atleast 8 chars long" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="my-2" controlId="confirmPassword">
          <Form.Label column="true" sm="3">
            <strong>
              Confirm Password <label style={{ color: "red" }}>*</label> :
            </strong>
          </Form.Label>
          <Col sm="6">
            <div style={{ display: "flex" }}>
              <InputGroup>
                <Form.Control
                  value={confirmPassword}
                  type={confirmPwdVisible ? "text" : "password"}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="confirm password"
                ></Form.Control>
                <Button
                  className="cyanThemeHeaderTop"
                  onClick={setConfirmPwdVisibility}
                >
                  {confirmPwdVisible ? <Eye /> : <EyeSlash />}
                </Button>
              </InputGroup>
            </div>
            {confirmPasswordPresent ? (
              <FieldWarning text="Password and Confirm Password are not matching" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="my-2" controlId="zutleSecret">
          <Form.Label column="true" sm="3">
            <strong>
              Zutle Secret <label style={{ color: "red" }}>*</label> :
            </strong>
          </Form.Label>
          <Col sm="6">
            <Form.Control
              type="password"
              autoComplete="off"
              value={zutleSecret}
              onChange={(e) => setZutleSecret(e.target.value)}
              placeholder="enter Zutle company creation secret"
            />
            {zutleSecretPresent ? (
              <FieldWarning text="Only Zutle staff can register companies" />
            ) : (
              ""
            )}
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="my-2" controlId="photo">
          <Form.Label column="true" sm="4">
            upload image :
          </Form.Label>
          <Col sm="6">
            <input
              type="file"
              onChange={handleFileChange}
              style={{ color: "white" }}
            />
            {fileSizeError && (
              <label style={{ color: "red" }}>
                Image size should be less than 5 MB, Please select different
                Image.
              </label>
            )}
            {fileInvalidError && (
              <label style={{ color: "red" }}>
                Only jpeg, jpg, png, tiff and svg formats are supported
              </label>
            )}
          </Col>
        </Form.Group>
        <Row className="mt-4">
          <Col className="text-center">
            <Button type="submit" variant="primary" onClick={submitHandler}>
              Register
            </Button>
          </Col>
          <Col className="text-center">
            <Button type="submit" variant="secondary" onClick={goToLogin}>
              Go to Login
            </Button>
          </Col>
        </Row>
      </Row>
    </Row>
  );
};

export default RegistrationScreen;
